import DateRange from '../selectComponents/DateRange';
import MultiVariableSelect from '../selectComponents/MultiVariableSelect';

export default function MeteogrfOptions(props) {
  const { userParams, setUserParams, selectOptions, handleChange, setDisableGoButton } = props;

  const variableChoices = [
    {value: 'temp',   label: 'Temperature'},
    {value: 'dwpt',   label: 'Dewpoint'},
//    {value: 'wchill', label: 'Wind Chill'},
//    {value: 'htindx', label: 'Heat Index'},
    {value: 'wetb',   label: 'Wet Bulb Temperature'},
    {value: 'rhum',   label: 'Relative Humidity'},
    {value: 'tsky',   label: 'Cloud cover'},
    {value: 'vis',    label: 'Visibility'},
    {value: 'pcpn',   label: 'Precipitation'},
    {value: 'wspd',   label: 'Wind Speed'},
    {value: 'wdir',   label: 'Wind Direction'},
    {value: 'wgust',  label: 'Wind Gust'},
    {value: 'slp',    label: 'Sea Level Pressure'},
    {value: 'altp',   label: 'Altimeter Setting'},
    {value: 'pres',   label: 'Station Pressure'},
  ]

  return (
    <>
      <DateRange 
        userParams={userParams}
        setUserParams={setUserParams}
      />
      <MultiVariableSelect 
        userParams={userParams}
        setUserParams={setUserParams}
        productVariableChoices={variableChoices}
      />
    </>
  )
}
